export default __webpack_public_path__ + "static/medme-bb8dd75b87fd5dd599e87d69b330a4f3.png";